import React, { useContext } from 'react';
import { LoginContext } from '../../context/LoginContext';
import PublicHeader from '../home/Header';
import PublicFooter from '../Footer';
import MemberHeader from '../profiles/Header';
import MemberFooter from '../profiles/Footer';

/**
 * Wraps pages that are reachable both by visitors and by signed-in members.
 * The member header fires logged-in-only requests and offers no way to join,
 * so visitors get the public header with its Sign Up / Login buttons instead.
 */
const PageChrome = ({ children }) => {
  const { isLoggedIn } = useContext(LoginContext);
  const Header = isLoggedIn ? MemberHeader : PublicHeader;
  const Footer = isLoggedIn ? MemberFooter : PublicFooter;

  return (
    <div>
      <Header />
      {children}
      <Footer />
    </div>
  );
};

export default PageChrome;
